import { createFileRoute, redirect } from '@tanstack/react-router'
import { LiveData } from '@/components/installFlowV2/live-data'
import { z } from 'zod'
import { isAuthenticated } from '@/auth';
import {
  installFlowInstallationId,
  installFlowLocationId,
  installFlowSublocationId,
  installFlowSensorKitSerial,
  installFlowOrganizationId,
} from '@/installFlow/storage-keys';

export const Route = createFileRoute('/installFlow/live-data')({
  component: LiveData,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
    const installationId   = installFlowInstallationId.get() ?? "";
    const locationId       = installFlowLocationId.get() ?? "";
    const sublocationId    = installFlowSublocationId.get() ?? "";
    const serialNumber     = installFlowSensorKitSerial.get() ?? "";
    const organizationId   = installFlowOrganizationId.get() ?? "";

    if (!installationId || !locationId || !sublocationId || !serialNumber || !organizationId) {
      throw redirect({ to: "/installFlow/sensor-scan" });
    }
  },
})

